import React, { useRef } from 'react';


const Testimonial = () => {

    const geetIframe = useRef(null);

    function handleIframe() {
        const iframeItem = geetIframe.current;
        // const nav = iframeItem.contentWindow.getElementsByTagName("nav");
        // nav.innerHTML = "";
    }


    return (
        <section className="wpo-testimonial-section section-padding">
            <div className="container">
                <div className="wpo-testimonial-wrap">
                    <div className="row align-items-center">
                        <div className="col-lg-12 col-12">
                            <div className="wpo-testimonial-items">
                                <a href={'https://github.com/moh-affan'} target={'_blank'}>
                                    <img src="https://raw.githubusercontent.com/moh-affan/moh-affan/main/github-metrics.svg"
                                        style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', width: '50%', backgroundColor: 'rgba(13,17,23,.8)', borderRadius: 20 }} />
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="left-shape"></div>
        </section>
    );
}

export default Testimonial;